import { httpGet } from "../http";
import { femaCapture } from "../../fema/capture";
import { sharePageEndpoints } from "../endpoints";
import {
  ApiResponse,
  CustomerSharingResponse,
  FreePostDataResponse,
  ServiceResponse,
} from "../types";

export class SharePageService {
  static async getCustomerSharing(
    customerId: string | number
  ): ServiceResponse<any[]> {
    try {
      const response = await httpGet<ApiResponse<CustomerSharingResponse[]>>(
        sharePageEndpoints.getCustomerSharing(customerId)
      );

      return response.data;
    } catch (error) {
      femaCapture("share_page_data_error", error, {
        category: "api",
        severity: "error",
        skipSanitization: false,
        user: {},
      });

      throw error;
    }
  }

  static async getFreePostData(
    customerId: string | number
  ): ServiceResponse<any[]> {
    try {
      const response = await httpGet<ApiResponse<FreePostDataResponse[]>>(
        sharePageEndpoints.getFreePostCustomerSharing(customerId)
      );

      return response.data;
    } catch (error) {
      femaCapture("free_post_data_error", error, {
        category: "api",
        severity: "error",
        skipSanitization: false,
        user: {},
      });

      throw error;
    }
  }
}
